

export   const formatTime = (time: string) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minutes} ${period}`;
  };

  // Format patient count (e.g., 2601 -> 2.6K+, 10 -> 10)
 export function formatPatientCount(count: number): string {
    if (!count || count < 0) return "0";
    if (count < 1000) return count.toString();
    
    const thousands = count / 1000;
    if (thousands >= 1) {
      return `${thousands.toFixed(1)}K+`;
    }
    
    return count.toString();
  }